var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1163 27.7166L30.1297 27.7962C30.2869 28.7264 30.3655 29.1915 30.6096 29.5673C30.6823 29.6791 30.7651 29.784 30.857 29.8805C31.1661 30.2048 31.5999 30.3882 32.4675 30.755C33.7713 31.3062 34.4232 31.5818 35.0486 31.4721C35.2322 31.4398 35.4109 31.3839 35.5802 31.3056C36.1566 31.039 36.5398 30.4343 37.3061 29.2248C38.1053 27.9634 38.5049 27.3327 38.4476 26.613C38.4347 26.4517 38.3928 26.2471 38.3411 26.0938C38.1106 25.4096 37.5689 25.0383 36.4853 24.2955C29.1503 19.2674 20.3271 19.2674 12.9921 24.2955C11.9085 25.0383 11.3668 25.4096 11.1363 26.0938C11.0846 26.2471 11.0427 26.4517 11.0298 26.613C10.9725 27.3327 11.3721 27.9634 12.1713 29.2248C12.9376 30.4343 13.3208 31.039 13.8972 31.3056C14.0665 31.3839 14.2452 31.4398 14.4288 31.4721C15.0542 31.5818 15.7061 31.3062 17.0099 30.755C17.8775 30.3882 18.3113 30.2048 18.6203 29.8805C18.7123 29.784 18.7951 29.6791 18.8678 29.5673C19.1119 29.1915 19.1905 28.7264 19.3476 27.7962L19.3611 27.7166C19.5233 26.7565 19.6044 26.2764 19.9602 25.8361C20.01 25.7745 20.1006 25.6768 20.1582 25.6224C20.5698 25.2342 20.9331 25.1443 21.6597 24.9644C23.6167 24.4799 25.8607 24.4799 27.8177 24.9644C28.5442 25.1443 28.9075 25.2342 29.3192 25.6224C29.3768 25.6768 29.4674 25.7745 29.5172 25.8361C29.873 26.2764 29.9541 26.7565 30.1163 27.7166Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.17551,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.62ea01dc1c0c42b32427627cf8b75700.svg";
export { ForwardRef as ReactComponent };